import React from 'react'

import { DEFAULT_INFO_TOOLTIP_COLOR, FA_1X, TOOLTIP_TOP } from '../utils/Constants'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from 'antd'
import { connect, mapDispatchToProps, mapStateToProps } from '../../../../reducers/Dispatchers'

const IconTooltip = ({ icon, iconColor, placement, size = FA_1X, title, t }) => {
  return (
    <Tooltip
      placement={placement ?? TOOLTIP_TOP}
      title={t(title)}
    >
      <FontAwesomeIcon
        icon={icon ?? faInfoCircle} color={iconColor ?? DEFAULT_INFO_TOOLTIP_COLOR}
        size={size}
      />
    </Tooltip>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(IconTooltip)
